import indicators from "./emergency-indicators.json";

export const EMERGENCY_CORE_REQUIRED_INDICATOR_IDS = [1, 2, 11, 12, 16];
export default indicators;
